<template>
    <div class="footer-box">
        <!-- ===== PC 端 ===== -->
        <div class="footer">
            <div class="footer-main">
                <!-- 联系我们：左侧蓝色块，无二维码 -->
                <div class="contact">
                    <h4>联系我们</h4>
                    <div class="row">
                        <i class="el-icon-location-outline"></i>
                        <p>{{ center.company_address }}</p>
                    </div>
                    <div class="row">
                        <i class="el-icon-message"></i>
                        <p>{{ center.company_hottel }}</p>
                    </div>
                    <div class="row">
                        <i class="el-icon-phone-outline"></i>
                        <p>{{ center.company_tel }}</p>
                    </div>
                    <div class="row">
                        <i class="el-icon-printer"></i>
                        <p>{{ center.company_tax }}</p>
                    </div>
                </div>

                <!-- 快速链接：3 列 × 2 行紧凑居中 -->
                <div class="quicklink">
                    <h4>快速链接</h4>
                    <ul>
                        <li v-for="(item, index) in list" :key="index" @click="jump(item)">
                            <span>{{ item.name }}</span>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- 备案号区 -->
            <div class="footer-copyright">
                <div class="copyright-main">
                    {{ center.filings_content || '© 重庆巨琪诺美制药有限公司' }}
                </div>
                <div class="copyright-beian">
                    <a class="beian-item" href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
                        <i class="el-icon-document"></i>
                        <span>渝ICP备18003728号</span>
                    </a>
                    <span class="beian-divider">|</span>
                    <a class="beian-item" href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank" rel="noopener noreferrer">
                        <img class="beian-icon" :src="beianIcon" alt="">
                        <span>渝公网安备50023302000196号</span>
                    </a>
                    <span class="beian-divider">|</span>
                    <a class="beian-item" href="https://www.nmpa.gov.cn" target="_blank" rel="noopener noreferrer">
                        <i class="el-icon-first-aid-kit"></i>
                        <span>渝网药械信备字[2026]000125号</span>
                    </a>
                </div>
            </div>
        </div>

        <!-- ===== 移动端 ===== -->
        <div class="iphone-footer">
            <div class="quicklink">
                <h4>快速链接</h4>
                <ul>
                    <li v-for="(item, index) in list" :key="index" @click="jump(item)">
                        <span>{{ item.name }}</span>
                    </li>
                </ul>
            </div>
            <div class="iphone-contact">
                <h4>联系我们</h4>
                <div class="row">
                    <i class="el-icon-location-outline"></i>
                    <p>{{ center.company_address }}</p>
                </div>
                <div class="row">
                    <i class="el-icon-message"></i>
                    <p>{{ center.company_hottel }}</p>
                </div>
                <div class="row">
                    <i class="el-icon-phone-outline"></i>
                    <p>{{ center.company_tel }}</p>
                </div>
                <div class="row">
                    <i class="el-icon-printer"></i>
                    <p>{{ center.company_tax }}</p>
                </div>
            </div>

            <!-- 移动端备案号区 -->
            <div class="iphone-copyright">
                <div class="copyright-main">
                    {{ center.filings_content || '© 重庆巨琪诺美制药有限公司' }}
                </div>
                <div class="copyright-beian">
                    <a class="beian-item" href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
                        <span>渝ICP备18003728号</span>
                    </a>
                    <a class="beian-item" href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank" rel="noopener noreferrer">
                        <img class="beian-icon" :src="beianIcon" alt="">
                        <span>渝公网安备50023302000196号</span>
                    </a>
                    <a class="beian-item" href="https://www.nmpa.gov.cn" target="_blank" rel="noopener noreferrer">
                        <span>渝网药械信备字[2026]000125号</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getcontact } from "@/api/index";
export default {
    data() {
        return {
            list: [
                { name: '首页', url: 'home', id: 1 },
                { name: '关于我们', id: 1, url: 'Aboutus' },
                { name: '产品展示', id: 1, url: 'Medicalsupplies' },
                { name: '新闻中心', id: 1, url: 'news' },
                { name: '在线反馈', id: 1, url: 'consultation' },
                { name: '联系我们', id: 1, url: 'contactus' }
            ],
            center: {},
            beianIcon: require('@/assets/img/beian.png'),
            lists: [{ name: '首页', url: 'home', id: 1 }]
        };
    },
    created() {
        this.getinformation();
    },
    methods: {
        getinformation() {
            getcontact().then((res) => {
                if (res && res.data && res.data.rows && res.data.rows[0]) {
                    this.center = res.data.rows[0];
                    localStorage.setItem('cnenter', this.center.company_memo_content);
                }
            });
        },
        jump(item) {
            this.lists = [{ name: '首页', url: 'home', id: 1 }];
            this.lists.push(item);
            if (item.name !== '首页') {
                this.lists.push(item);
                let a = JSON.stringify(this.lists);
                sessionStorage.setItem('mun', a);
            }
            this.$router.push({ name: item.url });
        }
    }
};
</script>

<style lang="scss" scoped>
/* ===== PC Footer ===== */
.footer {
    width: 100%;
    background-color: rgb(29, 51, 74);

    .footer-main {
        width: 70%;
        max-width: 1200px;
        margin: 0 auto;
        display: flex;
        align-items: stretch;
        justify-content: flex-start;
        gap: 80px;
        box-sizing: border-box;
    }

    /* 联系我们：蓝色块，与 jqnmzy 官网一致 */
    .contact {
        flex: 0 0 300px;
        width: 300px;
        background-color: rgb(32, 127, 221);
        padding: 33px 63px 30px;
        color: #fff;
        border-radius: 2px;

        h4 {
            font-size: 17px;
            font-weight: 500;
            margin-bottom: 22px;
            letter-spacing: 1px;
        }

        .row {
            display: flex;
            align-items: flex-start;
            margin-bottom: 16px;
            line-height: 1.5;

            &:last-child { margin-bottom: 0; }

            i {
                font-size: 14px;
                flex-shrink: 0;
                margin-right: 10px;
                margin-top: 3px;
                color: rgba(255, 255, 255, 0.85);
            }

            p {
                margin: 0;
                font-size: 13px;
                color: rgb(208, 232, 255);
                word-break: break-all;
            }
        }
    }

    /* 快速链接：2 列 × 3 行，列距宽松，与 jqnmzy 官网一致 */
    .quicklink {
        padding: 28px 0 24px;

        h4 {
            font-size: 18px;
            color: rgb(255, 255, 255);
            margin-bottom: 28px;
            letter-spacing: 1px;
        }

        ul {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 16px 80px;
            list-style: none;
            margin: 0 auto;
            padding: 0;
            max-width: 640px;

            li {
                height: 36px;
                color: #8ca5bb;
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                transition: color 0.2s ease;

                span {
                    position: relative;
                    padding-bottom: 2px;

                    &::after {
                        content: '';
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 0;
                        height: 1px;
                        background-color: #d8e9ff;
                        transition: width 0.25s ease;
                    }
                }

                &:hover {
                    color: #fff;
                    span::after { width: 100%; }
                }
            }
        }
    }

    /* 备案号区 */
    .footer-copyright {
        width: 100%;
        background-color: rgb(19, 35, 51);
        padding: 16px 16px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: rgb(140, 165, 187);
        font-size: 12px;
        text-align: center;
        box-sizing: border-box;

        a {
            color: rgb(140, 165, 187);
            font-size: 12px;
            text-decoration: none;
        }

        .copyright-main { margin-bottom: 4px; line-height: 1.8; }

        .copyright-beian {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            gap: 4px 10px;
            line-height: 1.8;

            .beian-item {
                display: inline-flex;
                align-items: center;
                gap: 4px;
                white-space: nowrap;
                transition: color 0.25s ease;

                .beian-icon, i {
                    width: 14px;
                    height: 14px;
                    object-fit: contain;
                    font-size: 14px;
                }

                &:hover {
                    color: #d8e9ff;
                    text-decoration: underline;
                }
            }

            .beian-divider {
                color: rgba(140, 165, 187, 0.6);
                margin: 0 2px;
            }
        }
    }
}

/* ===== 移动端 ===== */
.iphone-footer {
    display: none;
}

@media screen and (max-width: 992px) {
    .footer { display: none; }

    .iphone-footer {
        display: block;
        background-color: rgb(29, 51, 74);
        color: #fff;

        .quicklink {
            padding: 24px 16px 16px;
            border-bottom: 1px solid rgba(255, 255, 255, 0.08);

            h4 {
                font-size: 16px;
                margin-bottom: 14px;
                letter-spacing: 1px;
            }

            ul {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                gap: 4px 12px;
                list-style: none;
                margin: 0;
                padding: 0;

                li {
                    height: 32px;
                    font-size: 12px;
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                }
            }
        }

        .iphone-contact {
            padding: 20px 16px;
            background-color: rgb(35, 60, 86);

            h4 {
                font-size: 16px;
                margin-bottom: 14px;
                letter-spacing: 1px;
            }

            .row {
                display: flex;
                align-items: flex-start;
                margin-bottom: 10px;
                line-height: 1.4;

                &:last-child { margin-bottom: 0; }

                i {
                    font-size: 13px;
                    flex-shrink: 0;
                    margin-right: 8px;
                    margin-top: 2px;
                    color: rgba(255, 255, 255, 0.85);
                }

                p {
                    margin: 0;
                    font-size: 12px;
                    color: rgb(208, 232, 255);
                    word-break: break-all;
                }
            }
        }

        /* 移动端备案号区 */
        .iphone-copyright {
            background-color: rgb(19, 35, 51);
            padding: 14px 16px;
            color: rgb(140, 165, 187);
            font-size: 12px;
            text-align: center;
            line-height: 1.8;

            .copyright-main {
                margin-bottom: 4px;
            }

            .copyright-beian {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 4px;

                .beian-item {
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                    color: rgb(140, 165, 187);
                    text-decoration: none;
                    font-size: 11px;
                    white-space: nowrap;
                    transition: color 0.25s ease;

                    .beian-icon {
                        width: 12px;
                        height: 12px;
                        object-fit: contain;
                    }

                    &:hover {
                        color: #d8e9ff;
                        text-decoration: underline;
                    }
                }
            }
        }
    }
}
</style>
